import { formatClassLabel } from '../constants/classes';

/** Open printable syllabus and trigger browser Save as PDF. */
export function downloadSyllabusPdf(className, syllabusRows, schoolName = 'Modern Public School') {
  const cls = formatClassLabel(className);
  const body = (syllabusRows || [])
    .map(
      (row) => `
      <section style="margin-bottom:24px;page-break-inside:avoid;">
        <h2 style="margin:0 0 8px;font-size:16px;color:#1e3a5f;">${row.subject || 'Subject'}</h2>
        <div style="white-space:pre-wrap;font-size:13px;line-height:1.5;">${escapeHtml(row.content || '')}</div>
      </section>`
    )
    .join('');

  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"/><title>Syllabus ${cls}</title>
  <style>body{font-family:Segoe UI,Arial,sans-serif;padding:32px;max-width:800px;margin:0 auto;color:#111;}
  h1{font-size:22px;margin-bottom:4px;} .meta{color:#555;font-size:13px;margin-bottom:24px;}</style></head>
  <body><h1>${escapeHtml(schoolName)}</h1>
  <div class="meta">Class <strong>${escapeHtml(cls)}</strong> — Syllabus</div>
  ${body || '<p>No syllabus entries for this class.</p>'}
  </body></html>`;

  const w = window.open('', '_blank');
  if (!w) {
    alert('Allow pop-ups to download / print the syllabus PDF.');
    return;
  }
  w.document.write(html);
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 400);
}

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function parseSyllabusCsv(text) {
  const lines = String(text || '')
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean);
  if (lines.length < 2) return [];
  const rows = [];
  for (let i = 1; i < lines.length; i += 1) {
    const parts = lines[i].split(',');
    if (parts.length < 3) continue;
    const className = parts[0].trim();
    const subject = parts[1].trim();
    const content = parts.slice(2).join(',').trim();
    if (className && subject) rows.push({ className, subject, content });
  }
  return rows;
}
